import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import VideoCard from 'components/Motion_Detection/Videos/video-access-sd-card-windows';
import NavButtons from 'components/Motion_Detection/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "SD Karte Zugriff",
  "path": "/Bewegungserkennung/SD_Karten_Zugriff/Video/Windows/",
  "dateChanged": "2017-11-27",
  "author": "Mike Polinowski",
  "excerpt": "Die Kameraaufnahmen lassen sich lokal auf der ausgestatteten SD-Karte speichern und man kann direkt auf sie via InstarVision App, INSTAR Camera Tool, Web-Oberfläche, Windows- und macOS-Software zugreifen.",
  "image": "./MD_SearchThumb_SDCardAccess.png",
  "social": "/images/Search/MD_SearchThumb_SDCardAccess.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_MD-SD-Card_white.webp",
  "chapter": "Motion Detection"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <SEOHelmet title='SD-Karte Zugriff auf INSTAR IP Kameras – INSTAR Wiki' dateChanged='2017-11-27' author='Mike Polinowski' tag='INSTAR IP Camera' description='Die Kameraaufnahmen lassen sich lokal auf der ausgestatteten SD-Karte speichern und man kann direkt auf sie via InstarVision App, INSTAR Camera Tool, Web-Oberfläche, Windows- und macOS-Software zugreifen.' image='/images/Search/MD_SearchThumb_SDCardAccess.png' twitter='/images/Search/MD_SearchThumb_SDCardAccess.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Motion_Detection/SD_Card_Access/' locationFR='/fr/Motion_Detection/SD_Card_Access/' crumbLabel="SD Card" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <h1 {...{
      "id": "sd-karten-zugriff",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#sd-karten-zugriff",
        "aria-label": "sd karten zugriff permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`SD Karten Zugriff`}</h1>
    <h2 {...{
      "id": "instar-kamera-tool-windows",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#instar-kamera-tool-windows",
        "aria-label": "instar kamera tool windows permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`INSTAR Kamera Tool (Windows)`}</h2>
    <p>{`Bei den 720p, 1080p und 1440p Kameramodellen können Sie auf der internen SD-Karte aufzeichnen. Der einfachste Weg, auf Ihre Alarmaufzeichnungen zuzugreifen, ist die Verwendung unserer Smartphone-Apps. Auf dem Windows PC geht dies aber auch direkt mit dem INSTAR Kamera Tool.`}</p>
    <EuiSpacer mdxType="EuiSpacer" />
    <VideoCard mdxType="VideoCard" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      